import { render, staticRenderFns } from "./ColoredSlider.vue?vue&type=template&id=29b916e0&scoped=true"
import script from "./ColoredSlider.vue?vue&type=script&lang=js"
export * from "./ColoredSlider.vue?vue&type=script&lang=js"
import style0 from "./ColoredSlider.vue?vue&type=style&index=0&id=29b916e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b916e0",
  null
  
)

export default component.exports